// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3TM8g","messages":"Chat_messages__3Hd5c","dateDivider":"Chat_dateDivider__1VNBS"};